import React, { useState } from "react";

import { makeStyles } from '@material-ui/core/styles';
import { Collapse, Grid, TextField, Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { appConfig } from '../config.js';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    gridPadding: {
        padding: '10px'
    },
}));

const Login = ({ logged, onLogin }) => {

    const baseURL = appConfig.api.URL;
    const classes = useStyles();
    const [hasError, setHasError] = useState(false);

    const doLogin = async (username, password) => {
        let url = `${baseURL}/api-token-auth/`;
        fetch(url, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                username: username,
                password: password
            })
        })
            .then(results => results.json())
            .then(data => {
                console.log(data);
                if (data.token) {
                    const token = data.token;
                    document.cookie = `vanu_ems_token=${token}; path=/; max-age=604800`;
                    document.cookie = `vanu_ems_user=${username}; path=/; max-age=604800`;
                    onLogin(token, username);
                } else {
                    setHasError(true);
                }
            }
            )
            .catch((error) => {
                console.log(error);
            });
    }

    const handleSubmitLogin = (e) => {
        e.preventDefault();

        const username = e.target.elements.username.value;
        const password = e.target.elements.password.value;

        doLogin(username, password);

    }

    return (
        <div>
            <Collapse in={hasError}>
                <Alert severity="error" enabled="false">Please, use valid credentials!</Alert>
            </Collapse>

            <form onSubmit={handleSubmitLogin}>
                <Grid container className={classes.gridPadding}>

                    <Grid item xs={3}>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField id="username" label="Username" type="text" fullWidth autoFocus required />
                    </Grid>
                    <Grid item xs={3}>
                    </Grid>

                    <Grid item xs={3}>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField id="password" label="Password" type="password" fullWidth required />
                    </Grid>
                    <Grid item xs={3}>
                    </Grid>

                </Grid>
                <Grid container className={classes.gridPadding}>
                    <Grid item xs={5}>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                        >Login</Button>
                    </Grid>
                    <Grid item xs={5}>
                    </Grid>
                </Grid>
            </form >

        </div>
    )
}

export default Login;